import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../../common/reducers';

export const selectEngagementData = createSelector(
  (state: TRootState) => state.biEngagement,
  (biEngagement) => ({
    mouseClick: biEngagement.mouseClick,
    mouseMove: biEngagement.mouseMove,
    scroll: biEngagement.scroll,
    scrollToBottom: biEngagement.scrollToBottom,
    scrollAddedContent: biEngagement.scrollAddedContent,
    maxScrollAtFirstPosition: biEngagement.maxScrollAtFirstPosition,
    scrollPercentage: biEngagement.scrollPercentage,
  }),
);
